// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--LZE0a";
export var footerInner = "Footer-module--footerInner--s71N4";
export var footerAllRights = "Footer-module--footerAllRights--SvCjm";
export var footerSocialLinks = "Footer-module--footerSocialLinks--7xHbr";